// Store for coordinating delivery status filter navigation
// This allows the Header badges to communicate with the sales invoice list page
import { create } from 'zustand';

interface DeliveryFilterState {
    pendingFilter: string | null;
    setPendingFilter: (filter: string | null) => void;
    clearPendingFilter: () => void;
}

export const useDeliveryFilterStore = create<DeliveryFilterState>((set) => ({
    pendingFilter: null,
    setPendingFilter: (filter) => set({ pendingFilter: filter }),
    clearPendingFilter: () => set({ pendingFilter: null }),
}));
